const gridSize = {
  six: [0, 5],
  seven: [0],
  eight: [],
  nine: [0, 5, 6],
};

export const handleGridAssets = (i, grid) => gridSize[grid].indexOf(i) > -1;
